// Full-page navigation. Kept in its own module so tests can mock it: jsdom 26
// (Jest 30) makes window.location non-configurable, so tests can't replace it.
export function goTo(url) {
    window.location.href = url
}

export function reloadPage() {
    window.location.reload()
}
